import { API, setAuthToken } from '../../../config/API.js';
import {
  GET_DATA_KARIR,
  GET_DEPARTEMENT_KARIR,
  SET_LOADING_DATA_KARIR,
  SET_LOADING_DEPARTEMENT_KARIR,
  SET_PAGINATION_DATA_KARIR,
  SET_PAGINATION_DEPARTEMENT_KARIR,
} from '../constant.js';

export const getDepartementKarir = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_DEPARTEMENT_KARIR,
      payload: true,
    });
    API.get(`admin/career/department?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_DEPARTEMENT_KARIR,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_DEPARTEMENT_KARIR,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_DEPARTEMENT_KARIR,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_DEPARTEMENT_KARIR,
          payload: 0,
        });
      });
  };
};

export const addDepartementKarir = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/career/department/add", params);
};

export const getDetailDepartementKarir = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/career/department/${code}`);
};

export const updDepartementKarir = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/career/department/edit", params);
};

export const delDepartementKarir = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/career/department/delete/" + code);
};

export const getDataKarir = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_DATA_KARIR,
      payload: true,
    });
    API.get(`admin/career?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_DATA_KARIR,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_KARIR,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_DATA_KARIR,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_KARIR,
          payload: 0,
        });
      });
  };
};

export const addDataKarir = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/career/add", params);
};

export const getDetailDataKarir = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/career/${code}`);
};

export const updDataKarir = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/career/edit", params);
};

export const delDataKarir = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/career/delete/" + code);
};
